// extracted by mini-css-extract-plugin
export var loginPage = "loginPage-module--loginPage--2RJPH";
export var shapeFirst = "loginPage-module--shapeFirst--3fGHZ";
export var shapeSecond = "loginPage-module--shapeSecond--W4YPK";
export var content = "loginPage-module--content--2-1Do";
export var logo = "loginPage-module--logo--2Utah";
export var form = "loginPage-module--form--2XzIw";
export var fieldsGroup = "loginPage-module--fieldsGroup--1NFc-";
export var row = "loginPage-module--row--33-_q";
export var forgotPassword = "loginPage-module--forgotPassword--1tA10";